import React from "react";
import ReactDOM from "react-dom";
import { ReactPaceApp } from "./ReactPace";
import * as serviceWorker from "./serviceWorker";
import "modern-normalize";
import "typeface-red-hat-display";
import "typeface-montserrat";
import * as analytics from "./analytics";

analytics.initialize();
ReactDOM.render(
  <React.StrictMode>
    <ReactPaceApp />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
